<div class="login-container">
  <form [formGroup]="authForm" class="example-form">
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Email</mat-label>
      <input formControlName="email" matInput placeholder="" value="">
    </mat-form-field>
    <br>
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Password</mat-label>
      <input formControlName="password" type="password" matInput placeholder="" value="">
    </mat-form-field>
    <br>
    <button [disabled]="pending" mat-raised-button (click)="login()" color="primary">Submit</button>
  </form>
</div>
